import { render, staticRenderFns } from "./AssignmentActivityPage.vue?vue&type=template&id=4555df16&scoped=true&"
import script from "./AssignmentActivityPage.vue?vue&type=script&lang=ts&"
export * from "./AssignmentActivityPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4555df16",
  null
  
)

export default component.exports